import axios from "axios";
import { API_HOST } from "@/core/variables";
import { Synonym, SynonymCreate } from "@/model";

class SynonymRepository {
    create = async (agentId: number, synonymCreate: SynonymCreate) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/synonyms`,
                synonymCreate
            );
    };

    find = async (
        agentId: number,
        page: number,
        size: number,
        order: 'asc' | 'desc',
        keyword?: string
    ) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/synonyms`, {
            params: {
                page: page,
                size: size,
                order: order,
                keyword: keyword
            }
        });
    };

    update = async (agentId: number, updatedSynonym: Synonym) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}/synonyms/${updatedSynonym.id}`, {
            keyword: updatedSynonym.keyword,
            synonyms: updatedSynonym.synonyms
        });
    };

    deleteMany = async (agentId: number, ids?: string[], keyword?: string) => {
        const params = new URLSearchParams();
        ids?.forEach(id => params.append("ids", id));
        if (keyword)
            params.append("keyword", keyword);

        return axios.delete(`${API_HOST}/v1/agents/${agentId}/synonyms`, {
            params: params
        });
    };

    import = async (agentId: number, file: File, isCleanImport?: boolean) => {
        const form = new FormData();
        const is_clean_import = isCleanImport ? '1' : '0';
        form.append("file", file);
        form.append("is_clean_import", is_clean_import);

        return axios.post(`${API_HOST}/v1/agents/${agentId}/synonyms/import`, form);
    };

    export = (agentId: number, params?: {ids?: string[], keyword?: string}) => {
        const urlParams = new URLSearchParams();
        params?.ids?.forEach(id => urlParams.append("ids", id));
        if (params?.keyword) {
            urlParams.append("keyword", params.keyword);
        }
        window.open(`${API_HOST}/v1/agents/${agentId}/synonyms/export?${urlParams}`);
    };
}

const synonymRepository = new SynonymRepository();
export default synonymRepository;